<template>
    <div>
        <CList :pConfigList="ConfigList" :segurity="segurity">
            <template slot="Filtros">
                <div class="col-auto">
                    <label class="col-form-label">Ejecutivas V:</label>
                </div>
                <div class="col-auto">
                    <select @change="GetDatosGrafica" v-model="Filtro.IdVendedor" class="form-select form-control-search">
                        <option value="">Todos</option>
                        <option v-for="(item,ind) in Vendedores" :key="ind" :value="item.IdUsuario">{{item.NombreCompleto}}</option>
                    </select>
                </div>
                <div class="col-auto">
                    <label class="col-form-label">Gerentes o Cord:</label>
                </div>
                <div class="col-auto">
                    <select @change="GetDatosGrafica" v-model="Filtro.IdContacto" class="form-select form-control-search">
                        <option value="">Todos</option>
                        <option v-for="(item,ind) in Coordinadores" :key="ind" :value="item.IdUsuario">{{item.NombreCompleto}}</option>
                    </select>
                </div>
                <div class="col-auto">
                    <label class="col-form-label">Hoteles / Empresas:</label>
                </div>
                <div class="col-auto">
                    <select @change="GetDatosGrafica" v-model="Filtro.IdAgente" class="form-select form-control-search">
                        <option value="">Todos</option>
                        <option v-for="(item,ind) in Agentes" :key="ind" :value="item.IdAgente">{{item.NombreComercial}}</option>
                    </select>
                </div>
                <div class="col-auto">
                    <button class="btn btn-primary" @click="CambiarMostrarFechas">Por Fechas</button>
                </div>
                
                <div v-show="MostrarFechas" class="row g-3 justify-content-center px-4">
                    <div class="col-auto">
                        <label for="">Por Meses</label>
                    </div>
                    <div class="col-auto">
                        <select @change="GetDatosGrafica" v-model="Filtro.Mes" class="form-select form-control-search">
                            <option value="">Todos</option>
                            <option v-for="(item,ind) in Meses" :key="ind" :value="item.Value">{{item.Tag}}</option>
                        </select>
                    </div>
                    <div class="col-auto">
                        <select @change="GetDatosGrafica" v-model="Filtro.Anio" class="form-select form-control-search">
                            <option v-for="(item,ind) in Anios" :key="ind" :value="item">{{item}}</option>
                        </select>
                    </div>
                    <div class="col-auto">
                        <label for="">o Por Rangos</label>
                    </div>
                    <div class="col-auto">
                        <Datepicker @input="GetDatosGrafica" v-model="Filtro.Inicio" :input-class="Setpicker.Style" :format="Setpicker.Formato" :language="Setpicker.Idioma" placeholder="Fecha Inicial"></Datepicker>
                    </div>
                    <div class="col-auto">
                        <Datepicker @input="GetDatosGrafica" v-model="Filtro.Fin" :input-class="Setpicker.Style" :format="Setpicker.Formato" :language="Setpicker.Idioma" placeholder="Fecha Final"></Datepicker>
                    </div>
                    <div class="col-auto">
                        <button @click="BorrarFechas" class="btn btn-primary"><i class="fa fa-trash"></i> Fechas</button>
                    </div>
                </div>
                
            </template>

            <template slot="bodyForm">
                <CLoader :pConfigLoad="ConfigLoad">
                    <template slot="BodyFormLoad">
                        <div class="row mt-3">
                            <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                                <div class="card text-white bg-primary h-75">
                                    <div class="card-body">
                                        <div class="card-body-icon">
                                            <i class="fa fa-fw fa-award"></i>
                                        </div>
                                        <h5 class="text-white">
                                            Meta de Ventas
                                            <br>
                                            $ {{ MetaVentas }}
                                        </h5>
                                    </div>
                                    <div class="card-footer clearfix small z-index-1">
                                        <span style="float:left;font-size:15px;">Plan {{ TipoPlan }}</span>
                                    </div>
                                </div>
                            </div>
                            <div v-if="!ConfigLoad.ShowLoader" class="col-xs-12 col-sm-12 col-md-8 col-lg-8">
                                <apexchart :height="GraficaMetaVentas.chartOptions.chart.height" :type="GraficaMetaVentas.chartOptions.chart.type" :options="GraficaMetaVentas.chartOptions" :series="GraficaMetaVentas.series"></apexchart>
                            </div>
                        </div>

                        <div class="row mt-3 justify-content-center">
                            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                <div class="card text-white bg-secondary h-100">
                                    <div class="card-body">
                                        <div class="card-body-icon">
                                            <i class="fa fa-fw fa-tags"></i>
                                        </div>
                                        <h5 class="text-white">
                                            Eventos Asignados
                                            <br>
                                            {{ EventosAsignados }}
                                        </h5>
                                    </div>
                                    <div class="card-footer clearfix small z-index-1">
                                        
                                    </div>
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                <div class="card text-white bg-info h-100">
                                    <div class="card-body">
                                        <div class="card-body-icon">
                                            <i class="fa fa-fw fa-file-text"></i>
                                        </div>
                                        <h5 class="text-white">
                                            Eventos Confirmados
                                            <br>
                                            {{ EventosConfirmados }}
                                        </h5>
                                    </div>
                                    <div class="card-footer clearfix small z-index-1">
                                        
                                    </div>
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                <div class="card text-white bg-success h-100">
                                    <div class="card-body">
                                        <div class="card-body-icon">
                                            <i class="fa fa-fw fa-percentage"></i>
                                        </div>
                                        <h5 class="text-white">
                                            Porcentaje de Cierre
                                            <br>
                                            {{ PorcentajeCierre }}%
                                        </h5>
                                    </div>
                                    <div class="card-footer clearfix small z-index-1">
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </CLoader>
            </template>
        </CList>
    </div>
</template>

<script>
import Calendar from '@/helpers/StaticComboBox.js';
const EmitEjecuta='seccionReportePreventas'
export default {
    name:'ReportePreventa',
    data() {
        return {
            ConfigList:{
                Title:'Reporte de Preventas',
                IsModal: false,
                BtnReturnShow: true,
                BtnNewShow: false,
                ShowFiltros: true,
                ShowPaginador: false,
                ShowSearch:false,
                ShowEntradas:false,
                TypeBody: 'Form',
				TitleFirst: 'Finanzas',
				EmitSeccion: EmitEjecuta,
            },
            ConfigLoad:{
                ShowLoader:true,
                ClassLoad:false
            },
            Filtro:{
                IdVendedor:'',
                IdContacto:'',
                IdAgente:'',
                Mes:'',
                Anio:new Date().getFullYear(),
                // Anio:'2023',
                Inicio:'',
                Fin:''
            },
            segurity:{},
            Setpicker:Calendar.calendarSettings,
            Vendedores:[],
            Coordinadores:[],
            Agentes:[],
            MostrarFechas:false,
            Meses:[
                {Tag:"Enero",Value:"1"},
                {Tag:"Febrero",Value:"2"},
                {Tag:"Marzo",Value:"3"},
                {Tag:"Abril",Value:"4"},
                {Tag:"Mayo",Value:"5"},
                {Tag:"Junio",Value:"6"},
                {Tag:"Julio",Value:"7"},
                {Tag:"Agosto",Value:"8"},
                {Tag:"Septiembre",Value:"9"},
                {Tag:"Octubre",Value:"10"},
                {Tag:"Noviembre",Value:"11"},
                {Tag:"Diciembre",Value:"12"}
            ],
            Anios:[],
            MetaVentas:0,
            TipoPlan:'Sin plan',
            EventosAsignados:0,
            EventosConfirmados:0,
            PorcentajeCierre:0,
            GraficaMetaVentas:{
                chartOptions:{
                    chart:{
                        type:'line',
                        height:'250'
                    },
                    stroke:{
                        curve:'smooth',
                        width:3
                    },
                    xaxis:{
                        categories:["Ene","Feb","Mar","Abr","May","Jun","Jul","Ago","Sep","Oct","Nov","Dic"]
                    },
                    dataLabels:{
                        enabled:true,
                        background:{
                            borderRadius:10
                        }
                    },
                    fill:{
                        colors:['#3B97B2']
                    },
                    title: {
                        text: 'Meta de Ventas',
                        align: 'center'
                    },
                },
                series:[
                    {
                        name:"Monto Acumulado",
                        data:[0,0,0,0,0,0,0,0,0,0,0,0]
                    }
                ]
            }
        }
    },
    methods: {
        async GetDatosGrafica(){
            this.ConfigLoad.ShowLoader=true;
            let FechaInicio='';
            let FechaFin='';
            if (this.Filtro.Inicio!='') {
                let YearInicio=this.Filtro.Inicio.getFullYear();
                let MonthInicio=this.Filtro.Inicio.getMonth()+1;
                let DayInicio=this.Filtro.Inicio.getDate();
                FechaInicio=YearInicio+'-'+MonthInicio+'-'+DayInicio;
            }
            if (this.Filtro.Fin!='') {
                let YearFin=this.Filtro.Fin.getFullYear();
                let MonthFin=this.Filtro.Fin.getMonth()+1;
                let DayFin=this.Filtro.Fin.getDate();
                FechaFin=YearFin+'-'+MonthFin+'-'+DayFin;
            }

            await this.$http.get('reportePreventas',{
                params:{
                    IdVendedor:this.Filtro.IdVendedor,
                    IdContacto:this.Filtro.IdContacto,
                    IdAgente:this.Filtro.IdAgente,
                    Mes:this.Filtro.Mes,
                    Anio:this.Filtro.Anio,
                    Inicio:FechaInicio,
                    Fin:FechaFin
                }
            }).then((res)=>{
                this.MetaVentas=res.data.data.MontoPlanVenta;
                this.TipoPlan=res.data.data.TipoPlanVenta;
                this.EventosAsignados=res.data.data.EventosAsignados;
                this.EventosConfirmados=res.data.data.EventosConfirmados;
                this.PorcentajeCierre=res.data.data.PorcentajeCierre;
                this.GraficaMetaVentas.chartOptions.xaxis.categories=res.data.data.GraficaMetaVentas.labels;
                this.GraficaMetaVentas.series[0].data=res.data.data.GraficaMetaVentas.values;
            }).finally(()=>{
                this.ConfigLoad.ShowLoader=false;
            })
        },
        CambiarMostrarFechas(){
            this.MostrarFechas=this.MostrarFechas ? false : true;
        },
        BorrarFechas(){
            this.Filtro.Inicio='';
            this.Filtro.Fin='';
            this.GetDatosGrafica();
        },
        GetFiltros(){
            this.$http.get('finanzasGraficasFiltros',{
                params:{
                    Anio:new Date().getFullYear(),
                    Vendedores:true,
                    Coordinadores:true
                }
            }).then((res)=>{
                this.Agentes=res.data.data.Agentes;
                this.Anios=res.data.data.Anios;
                this.Vendedores=res.data.data.Vendedores;
                this.Coordinadores=res.data.data.Coordinadores;
                this.Anios.push(new Date().getFullYear());
            })
        }
    },
    mounted() {
        this.GetFiltros();
        this.GetDatosGrafica();
    },
}
</script>

<style>

</style>